import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import Button from "ds/Button";
import Modal from "ds/Modal";

import * as S from "./DeploymentTypeSetting.styles";

type Props = {
  closeModal: () => void;
  confirmDeploymentTypeChangeModal: boolean;
  onChangeDeploymentTypeSave: (e: React.MouseEvent) => void;
  cancel: () => void;
};

export const DeploymentTypeChangeModal = ({
  confirmDeploymentTypeChangeModal,
  closeModal,
  onChangeDeploymentTypeSave,
  cancel
}: Props) => {
  const intl = useIntl();

  const onCancelClick = () => {
    closeModal();
    cancel();
  };
  const onSaveAndDeployClick = e => {
    onChangeDeploymentTypeSave(e);
  };

  return (
    <Modal
      isOpen={confirmDeploymentTypeChangeModal}
      onOpenChange={onCancelClick}
      size="medium"
    >
      <Typography.Title tag="h3">
        {intl.formatMessage({
          id: "environment.settings.deployment_type.confirm_modal.title"
        })}
      </Typography.Title>
      <Typography.BodyText>
        {intl.formatMessage(
          {
            id: "environment.settings.deployment_type.confirm_modal.description"
          },
          { br: <br /> }
        )}
      </Typography.BodyText>

      <S.ButtonContainer justifyContent="end">
        <Button analyticId="cancel" variant="secondary" onClick={onCancelClick}>
          {intl.formatMessage({
            id: "cancel"
          })}
        </Button>
        <Button analyticId="" variant="primary" onClick={onSaveAndDeployClick}>
          {intl.formatMessage({
            id: "save_and_deploy"
          })}
        </Button>
      </S.ButtonContainer>
    </Modal>
  );
};
